import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import GlobalContext from "../../../framework/GlobalContext";
import NumberInput from "../../../framework/NumberInput";
import { displayToast } from "../../../framework/toast/toastUtils";
import TreeSelect from "../../../framework/tree-select";
import { getCategory } from "../../../services/category-services";

const AddDiscounts = (props) => {
  const {
    index,
    discountRowData,
    discounts,
    showDeleteIcon = true,
    onDeleteDiscount = () => {},
    onChange = () => {},
    isEdit = false,
  } = props;

  const { setCurrentComponent } = useContext(GlobalContext);

  const [productCategory, setProductCategory] = useState(null);
  const [productCategories, setProductCategories] = useState([]);
  const [errorStates, setErrorStates] = useState({});

  const productCategoryRef = useRef();

  const getMarker = useCallback(
    (direction, rowItemIndex, rowIndex) => {
      switch (direction) {
        case "right":
          if (rowItemIndex === 0) {
            return `row_item_1_${index}`;
          }
          if (rowItemIndex === 1) {
            if (document.getElementById(`row_item_0_${index + 1}`)) {
              return `row_item_0_${index + 1}`;
            }
            return `row_item_1_${index}`;
          }
          break;
        case "left":
          if (rowItemIndex === 0) {
            if (document.getElementById(`row_item_0_${index - 1}`)) {
              return `row_item_1_${index - 1}`;
            }
            return `row_item_0_${index}`;
          }
          if (rowItemIndex === 1) {
            return `row_item_0_${index}`;
          }
          break;
        case "up":
          return `row_item_${rowItemIndex}_${rowIndex}`;
        case "down":
          return `row_item_${rowItemIndex}_${rowIndex}`;
        default:
          return `row_item_${rowItemIndex}_${rowIndex}`;
      }
    },
    [index]
  );

  const keyupListener = useCallback(
    (event) => {
      const key = event.key?.toLowerCase();
      if (key === "delete") {
        onDeleteDiscount(index);
        return;
      }
    },
    [index, onDeleteDiscount]
  );

  const handleCategoryChange = useCallback(
    (newValue) => {
      const isDuplicate = discounts.some(
        (item) => item?.referenceId === newValue?.value?.id
      );
      if (isDuplicate) {
        displayToast({
          type: "error",
          title: "Product Category already exists",
        });
        return;
      }
      setProductCategory(newValue);
      onChange("referenceId", newValue?.value?.id);
      setErrorStates((prev) => ({
        ...prev,
        productCategory: false,
      }));
    },
    [discounts, onChange]
  );

  const fetchProductCategory = useCallback(async () => {
    await getCategory().then((response) => {
      setProductCategories(response);
    });
  }, []);

  useEffect(() => {
    fetchProductCategory();
  }, [fetchProductCategory]);

  useEffect(() => {
    window.addEventListener("keyup", keyupListener);
    return () => {
      window.removeEventListener("keyup", keyupListener);
    };
  }, [keyupListener]);

  return (
    <div
      style={{
        display: "flex",
        gap: "1rem",
        justifyContent: "space-between",
      }}
    >
      <div style={{ flex: 2 }}>
        <TreeSelect
          id={`row_item_0_${index}`}
          label="Product Category"
          allowMultiple={false}
          ref={productCategoryRef}
          value={!isEdit ? productCategory : discountRowData?.categoryData}
          name="productCategory"
          onFocus={() => {
            setCurrentComponent("add_discount_program_product_category");
          }}
          options={productCategories}
          getOptionLabel={(option) => {
            return option.value.categoryName || option;
          }}
          onChange={(e, newValue) => {
            handleCategoryChange(newValue);
          }}
          onBlur={
            !productCategory
              ? () => {
                  setErrorStates((prev) => {
                    return { ...prev, productCategory: true };
                  });
                  displayToast({
                    type: "error",
                    title: "Please enter product category",
                  });
                }
              : () => {}
          }
          required={true}
          error={errorStates.productCategory}
          inputProps={{
            "data-markers": JSON.stringify({
              up: getMarker("up", 0, index),
              down: getMarker("down", 0, index),
              left:
                getMarker("left", 0, index) === "row_item_0_0"
                  ? "add_discount_program_remarks"
                  : getMarker("left", 0, index),
              right: getMarker("right", 0, index),
            }),
          }}
        />
      </div>
      <div style={{ flex: 2 }}>
        <NumberInput
          id={`row_item_1_${index}`}
          label="Discount"
          value={discountRowData?.discPer}
          onChange={(e) => {
            const value = +e.target.value;
            if (value <= 99) {
              onChange("discPer", value);
            } else {
              onChange("discPer", 99);
            }
          }}
          onFocus={() => {
            setCurrentComponent("add_discount_program_discount");
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: getMarker("up", 1, index),
              down: getMarker("down", 1, index),
              left: getMarker("left", 1, index),
              right: getMarker("right", 1, index),
            }),
          }}
        />
      </div>
      {showDeleteIcon && (
        <IconButton
          onClick={() => onDeleteDiscount(index)}
          sx={{ transform: `translateY(-12px)` }}
        >
          <DeleteIcon />
        </IconButton>
      )}
    </div>
  );
};

export default AddDiscounts;
